import { useEffect } from 'react';

// Injects FAQPage JSON-LD for the page's visible FAQ sections (industry pages).
// Content mirrors the on-page accordion text exactly, per structured-data policy.
export default function FaqJsonLd({ sections, id }) {
  useEffect(() => {
    if (!sections) return undefined;
    const el = document.createElement('script');
    el.type = 'application/ld+json';
    el.dataset.faq = id;
    el.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: sections
        .flatMap((s) => s.items)
        .map((f) => ({
          '@type': 'Question',
          name: f.q,
          acceptedAnswer: { '@type': 'Answer', text: (Array.isArray(f.a) ? f.a : [f.a]).join('\n\n') },
        })),
    });
    document.head.appendChild(el);
    return () => el.remove();
  }, [sections, id]);
  return null;
}
